module.exports = __webpack_public_path__ + "static/media/line-dashed.7ae2af15.svg";